import Vue from "vue";
import Router from "vue-router";
import login from "@/login";
import HelloWorld from "@/components/HelloWorld";
import index from "@/views/index";
import register from "@/views/register";
import policy from "@/views/policy";
import home from "@/views/home";
import classStudy from "@/views/classStudy";
import certificate_list from "@/views/certificate_list";
import class_list from "@/views/class_list";
import examination from "@/views/examination";
import examination_list from "@/views/examination_list";
import training_list from "@/views/training_list";
import certificate_delivery from "@/views/certificate_delivery";

Vue.use(Router);

export default new Router({
//   mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: login
    },
    {
      path: "/home",
      name: "home",
      component: home
    },
    {
      path: "/training_list",
      name: "training_list",
      component: training_list
    },
    {
      path: "/certificate_list",
      name: "certificate_list",
      component: certificate_list
    },
    {
      path: "/certificate_delivery",
      name: "certificate_delivery",
      component: certificate_delivery
    },
    {
      path: "/class_list",
      name: "class_list",
      component: class_list
    },
    {
      path: "/examination_list",
      name: "examination_list",
      component: examination_list
    },
    {
      path: "/examination",
      name: "examination",
      component: examination
    },
    {
      path: "/classStudy",
      name: "classStudy",
      component: classStudy
    },
    {
      path: "/HelloWorld",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/index",
      name: "index",
      component: index
    },
    {
      path: "/register",
      name: "register",
      component: register
    },
    {
      path: "/policy",
      name: "policy",
      component: policy
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js